module.exports = __webpack_public_path__ + "static/media/MiniGamesHeader.dcac012b.png";